import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import DataTable, { Column } from "components/DataTable";
import { useTranslation } from "contexts/i18nContext";
import { fetchDicipline } from "services/prosecutorDecipilineService";
import { MobileDeciplineReport } from "types";
import { DateView } from "utils/helper";
import "./ReportByMobileRequests.css";
import { useHasRole } from "contexts/AuthContext";
import { ADVOCATE_ROLES, ROLES } from "utils/roles";

// const tabs = [
//   "All",
//   COMPLIANT_STATUS.PENDING,
//   COMPLIANT_STATUS.UNDER_INVESTIGATION,
//   COMPLIANT_STATUS.DRAFT_CHARGE,
//   COMPLIANT_STATUS.UNDER_LITIGATION,
//   COMPLIANT_STATUS.CLOSED,
// ];

const ReportByMobileRequests: React.FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  // const { user } = useAuth();
  // const canCreateComplaint = useHasRole([
  //   ROLES.INSPECTION_COORDINATOR,
  //   ROLES.INSPECTION_DIRECTOR,
  // ]);
  // const canViewAllComplaint = useHasRole([
  //   ROLES.INSPECTION_COORDINATOR,
  //   ROLES.INSPECTION_DIRECTOR,
  //   ROLES.INSPECTION_REGISTRAR,
  // ]);
  // const canOnlyViewAssignedComplaint = useHasRole([
  //   ROLES.INSPECTION_PROSECUTOR,
  // ]);
  // const canOnlyViewCouncilComplaint = useHasRole([
  //   ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  //   ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
  //   ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
  //   ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  // ]);

  // const isCouncelHead = useHasRole([ROLES.REGIONAL_COUNCIL_OFFICE_HEAD]);
  // const isProsecutor = useHasRole([ROLES.INSPECTION_PROSECUTOR]);
  // const byAdminUnit = useHasRole([
  //   ROLES.INSPECTION_COORDINATOR,
  //   ROLES.INSPECTION_REGISTRAR,
  //   ROLES.INSPECTION_DIRECTOR,
  //   // ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  //   ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  // ]);

  // const [activeTab, setActiveTab] = useState<string>("All");
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState("");
  const [reports, setReports] = useState<MobileDeciplineReport[]>([]);

  const isProsecutionCoordinator = useHasRole([ROLES.INSPECTION_COORDINATOR]);
  const isAdvocateCoordinator = useHasRole([
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
  ]);

  useEffect(() => {
    // setLoading(true);
    const loadData = async () => {
      try {
        const data = await fetchDicipline();
        setReports(
          data?.filter((d: any) =>
            isProsecutionCoordinator
              ? d?.is_on_prosecutor
              : isAdvocateCoordinator
                ? d?.is_on_advocate
                : false,
          ),
        );
        // setError("");
      } catch (err) {
        // setError("Failed to load complaint.");
      } finally {
        // setLoading(false);
      }
    };
    loadData();
  }, []);

  const columns: Column<MobileDeciplineReport>[] = [
    {
      header: t("reportApplicationNumber"),
      accessor: "report_application_number",
      render: (row) => row.report_application_number ?? "—",
    },
    {
      header: t("complainantName"),
      accessor: "complainant_name",
      render: (row) => row.complainant_name ?? "—",
    },
    {
      header: t("complainantPhone"),
      accessor: "complainant_phone",
      render: (row) => row.complainant_phone,
    },
    {
      header: t("accusedProsecutorName"),
      accessor: "accused_prosecutor_name",
      render: (row) => row.accused_prosecutor_name ?? "—",
    },
    {
      header: t("dateOfOffense"),
      accessor: "date_of_offense",
      render: (row) => DateView(row.date_of_offense),
    },

    {
      header: t("action"),
      accessor: "action",
      render: (row) => (
        <button
          onClick={() => navigate(`/report-by-mobile/${row?.id}`)}
          className="px-3 py-1 text-sm bg-black text-white rounded hover:bg-gray-800 transition"
        >
          {t("open")}
        </button>
      ),
    },
  ];

  return (
    <div className=" mx-auto flex flex-col space-y-4">
      <h1 className="text-2xl font-semibold text-gray-700 flex items-center gap-2 mb-5">
        <span>⚖</span>
        {t("disciplineReportByMobile")}
      </h1>

      <DataTable
        title={t("disciplineReportTable")}
        columns={columns}
        data={[...(reports || [])]}
        rowKey={(row) => row?.id as number}
        onSearch={(q) => {}}
      />
    </div>
  );
};

export default ReportByMobileRequests;
